import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

interface PageSignal {
  activePlan?: any; // Optional property for the selected plan
  [key: string]: any; // Allow for future signal extensions (optional)
}

@Injectable({
  providedIn: "root",
})
export class PageSignalService {
  private pageSignal: PageSignal = {};
  private pageSignalSubject = new Subject<PageSignal>();
  statusForCheckSuccess: boolean = false; // Initial value
  successDeviceList: any[] = [];

  private pageSuccessSignal: any = {};
  private pageSuccessSignalSubject = new Subject<any>();

  private modifySignal: any = {};
  private modifySignalSubject = new Subject<any>();

  setStatus(status: boolean) {
    this.statusForCheckSuccess = status;
  }

  setDeviceList(list: any[]) {
    this.successDeviceList = list;
  }

  public updateSignal(data: PageSignal) {
    this.pageSignal = data;
    this.pageSignalSubject.next(this.pageSignal);
  }

  public getSignal(): Subject<PageSignal> {
    return this.pageSignalSubject;
  }

  public updateSuccessSignal(data: any) {
    this.pageSuccessSignal = data;
    this.pageSuccessSignalSubject.next(this.pageSuccessSignal);
  }

  public getSuccessSignal(): Subject<any> {
    return this.pageSuccessSignalSubject;
  }

  public updateModifySignal(data: any) {
    this.pageSuccessSignal = data;
    this.pageSuccessSignalSubject.next(this.pageSuccessSignal);
  }

  public getModifySignal(): Subject<any> {
    return this.pageSuccessSignalSubject;
  }
}
